import * as Blockly from 'blockly';

export function synchronizeWorkspaceVariables(
  workspace: Blockly.Workspace,
  projectVariableNames: Iterable<string>
): void {
  const variableMap = workspace.getVariableMap();
  const projectVariables = new Set(projectVariableNames);

  for (const variableName of projectVariables) {
    if (!variableMap.getVariable(variableName)) {
      variableMap.createVariable(variableName);
    }
  }

  for (const variable of [...variableMap.getAllVariables()]) {
    const hasLocalUses = Blockly.Variables.getVariableUsesById(workspace, variable.getId()).length > 0;
    if (!hasLocalUses && !projectVariables.has(variable.getName())) {
      variableMap.deleteVariable(variable);
    }
  }
}
